module.exports = __webpack_public_path__ + "img/policy-card.b811b1f1.png";